<aside id="rule-{{name | RemoveWhitespace}}">
  <form [formGroup]="form" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()">
    <!-- TODO: THIS WILL GO, AS NOT STICKING WITH EXPANDING TABLE RULES - EDITING RULE NAME
               Rule name editing will move to header like in ADv2 modals
-->

    <section
      class="rule-content content grid-2">
      <div id="criteria">
        <h3 class="heading-underline">
          <span>Find all field values from</span>
          <button type="button" class="section-jump-link" [class.visible]="showViewActionsLink" (click)="scrollToSection('actions')">
            View Actions
            <i class="material-icons-outlined notranslate">keyboard_arrow_down</i>
          </button>
        </h3>
        <ul class="scrollable-container criteria-list">
          <li *ngFor="let criteriaGroup of criteria.controls; let i = index" id="rule-{{i}}">
            <section [ngClass]="[criteria.controls.length > 1 ? 'multiple-criteria': '']">
              <i *ngIf="i > 0" id=" remove-criteria-{{i}}" class="bhi-times" (click)="removeCriteria(i)"
                 [matTooltip]="'Remove this criteria'" matTooltipShowDelay="500"></i>
              <app-criteria
                id="rule-{{ruleIndex}}-criteria-{{i}}" [formGroup]="criteriaGroup"
                [criteria]="parseRawCriteria(dataRule.ruleData.source.config.criteria[i]) | async"
                [primaryEntity]="selectedEntity"
              ></app-criteria>
              <span *ngIf="i < criteria.controls.length - 1" class="and"> AND </span>
            </section>
          </li>
        </ul>
        <div class="criteria-footer-buttons">
          <button type="button" (click)="addNewCriteria()" theme="small"><i class="bhi-add-thin"></i> Add Criteria</button>
        </div>
      </div>
      <div id="actions">
        <h3 class="heading-underline" #actionsHeading>
          <span>Actions to manipulate field data</span>
          <button type="button" class="section-jump-link" (click)="scrollToSection('criteria')">
            View Criteria
            <i class="material-icons-outlined notranslate">keyboard_arrow_up</i>
          </button>
        </h3>
        <div class="message tip" [class.stacked-above-tip]="aiContentDisclaimerVariant"><i class="material-icons notranslate">info_outline</i> To amend an existing Rule action, please remove the
          field and re-add.
        </div>
        @if (aiContentDisclaimerVariant) {
          <app-ai-content-disclaimer [variant]="aiContentDisclaimerVariant" [stackedBelowTip]="true"></app-ai-content-disclaimer>
        }
        <div *ngIf="form.errors?.toOnes" class="rule-error">
          <section class="mat-warn"><i class="bhi-caution"></i>{{form.errors.toOnes.message}}</section>
        </div>
        <ul class="scrollable-container actions-list" #actionsList>
          <li *ngFor="let actionGroup of actions.controls; let i = index" [ngSwitch]="dataRule.ruleData.action.config.steps[i].type">
            <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.INSERT)">
              <!-- Check destinationType to differentiate between Certification and Note -->
              <section *ngIf="dataRule.ruleData.action.config.steps[i].destinationType === 'NOTE'">
                <i id="remove-add-note-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
                <app-action-add-note id="rule-{{ruleIndex}}-add-note-action-{{i}}"
                                   [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                   [actionForm]="actionGroup"
                                   [primaryEntity]="selectedEntity">
                </app-action-add-note>
              </section>
              <section *ngIf="dataRule.ruleData.action.config.steps[i].destinationType !== 'NOTE'">
                <i id="remove-insert-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
                <app-action-insert id="rule-{{ruleIndex}}-insert-action-{{i}}"
                                   [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                   [actionForm]="actionGroup"
                                   [primaryEntity]="selectedEntity">
                </app-action-insert>
              </section>
            </ng-container>

            <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.INSERT_MULTIPLE)">
              <section>
                <i id="remove-insert-multiple-action-{{i}}" class="bhi-times" (click)="removeAction(i)"></i>
                <app-action-insert-multiple id="rule-{{ruleIndex}}-insert-multiple-action-{{i}}"
                                            [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                            [actionForm]="actionGroup"
                                            [primaryEntity]="selectedEntity">
                </app-action-insert-multiple>
              </section>
            </ng-container>

            <ng-container
              *ngSwitchCase="dataRulesService.actionOpName(actionOperators.DELETE)">
              <section>
                <i id="remove-delete-action-{{i}}" class="bhi-times" (click)="setHardDelete(false)"></i>
                <app-hard-delete
                  [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                  [actionForm]="actionGroup"
                  [primaryEntity]="selectedEntity"
                ></app-hard-delete>
              </section>
            </ng-container>

            <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AIASSIST)">
              <section>
                <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
                <app-action-ai id="rule-{{ruleIndex}}-action-{{i}}"
                               [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                               [actionForm]="actionGroup"
                               [primaryEntity]="selectedEntity">
                </app-action-ai>
              </section>
            </ng-container>

            <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AIASSIST_NOTE)">
              <section>
                <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
                <app-action-ai id="rule-{{ruleIndex}}-action-{{i}}"
                               [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                               [actionForm]="actionGroup"
                               [primaryEntity]="selectedEntity">
                </app-action-ai>
              </section>
            </ng-container>

            <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.AWESOMEDOCS)">
              <section class="action-with-heading">
                <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
                <app-action-awesome-docs id="rule-{{ruleIndex}}-action-{{i}}"
                                         [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                         [actionForm]="actionGroup"
                                         [primaryEntity]="selectedEntity">
                </app-action-awesome-docs>
              </section>
            </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.ENRICH)">
            <section class="action-with-heading">
              <i id="remove-enrich-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-trust-score id="rule-{{ruleIndex}}-enrich-action-{{i}}"
                                      [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                      [actionForm]="actionGroup"
                                      [primaryEntity]="selectedEntity">
              </app-action-trust-score>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="dataRulesService.actionOpName(actionOperators.PARSE_RESUME)">
            <section class="action-with-heading">
              <i id="remove-parse-resume-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
              <app-action-parse-resume id="rule-{{ruleIndex}}-parse-resume-action-{{i}}"
                                       [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                                       [actionForm]="actionGroup"
                                       [primaryEntity]="selectedEntity">
              </app-action-parse-resume>
            </section>
          </ng-container>

            <ng-container *ngSwitchDefault>
              <section>
                <i id="remove-action-{{i}}" class="bhi-times" (click)="removeAction(i)" [matTooltip]="'Remove this action'" matTooltipShowDelay="500"></i>
                <!--          <app-actions id="rule-{{ruleIndex}}-action-{{i}}" [formGroup]="actionGroup" [actionData]="dataRule.ruleData.action.config.steps[i]" [fieldMetaData]="actionMeta"></app-actions>-->
                <app-action-x id="rule-{{ruleIndex}}-action-{{i}}"
                              [actionData]="parseRawAction(dataRule.ruleData.action.config.steps[i]) | async"
                              [actionForm]="actionGroup"
                              [primaryEntity]="selectedEntity">
                </app-action-x>
              </section>
            </ng-container>
          </li>
        </ul>

        <button class="actions-expand-toggle" type="button" theme="small" (click)="actionsExpanded = !actionsExpanded">
          <i class="bhi-add-thin"></i>
          {{ actionsExpanded ? 'Hide additional actions' : 'Show additional actions' }}
          <mat-icon>{{ actionsExpanded ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
        <div class="actions-footer-buttons" [class.expanded]="actionsExpanded" (transitionend)="onActionsFooterTransitionEnd($event)">
          <aside [ngClass]="'actions-buttons'">
            <!-- TODO: Show this button if destination is populated in last (FYI value is also populated in add-remove, change, replace) -->
            <!-- TODO: ngx-skeleton-loader can be done ourselves easily, pull it out -->
            <ng-container *ngIf="canSpawnAddActionButton()">
              <button class="add-action" theme="small" type="button" (click)="addNewAction()">
                <i class="bhi-field-add"></i>Add Action
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnCredentialRequirementButton()">
              <button class="add-credential-requirement" theme="small" type="button" (click)="addNewInsertCredentialsRequirementAction()">
                <i class="bhi-field-add"></i>Add Credential Requirement
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnMultipleCredentialRequirementButton()">
              <button class="add-credential-requirement-group" theme="small" type="button" (click)="addNewInsertMultipleCredentialsRequirementAction()">
                <i class="bhi-field-add"></i>Add Credential Requirements based on Certification Group
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnHardDeleteButton()">
              <button [ngClass]="{
                  'hard-delete': true,
                  'selected': isHardDelete.value
              }" theme="small" type="button"
                      (click)="setHardDelete(!isHardDelete.value)">
                <i class="bhi-field-add"></i>Hard delete
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnAddNoteButton()">
              <button (click)="addNewAddNoteAction()" theme="small" type="button">
                <i class="bhi-field-add"></i>Add Note
              </button>
            </ng-container>
          </aside>
          <aside [ngClass]="'actions-buttons'">
            <ng-container *ngIf="canSpawnAddAIActionButton()">
              <button (click)="addNewAIAction()" theme="small" type="button">
                <i class="bhi-field-add"></i>GENERATE KYLOE AI PROMPT
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnAddAwesomeDocsButton()">
              <button *ffEnabled="'datarules_awesome_docs_action'" (click)="addNewAwesomeDocsAction()" theme="small" type="button">
                <i class="bhi-field-add"></i>GENERATE KYLOE AWESOMEDOCS TEMPLATE
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnEnrichButton()">
              <button *ffEnabled="'datarules_enrichment_action'" (click)="addNewEnrichAction()" theme="small" type="button">
                <i class="bhi-field-add"></i>Enrichment
              </button>
            </ng-container>
            <ng-container *ngIf="canSpawnParseResumeButton()">
              <button *ffEnabled="FeatureFlagService.FLAGS.dataRulesParseResume" (click)="addNewParseResumeAction()" theme="small" type="button">
                <i class="bhi-field-add"></i>Parse Resume
              </button>
            </ng-container>
          </aside>
        </div>
      </div>
    </section>

    <mat-accordion
      *ngIf="currentRuleExamples && utilsService.compareInternalDataRuleIds(currentRuleExamples.id, dataRule.ruleData.id) && !form.dirty && form.valid"
      class="examples-accordion"
      @transitionNewHeightInOut>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="material-icons-outlined">search</mat-icon>
            Examples found
            <mat-panel-description>Preview results for this rule</mat-panel-description>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-examples-found id="examples-found"
                            class="standalone-button"
                            [currentRuleExamples]="currentRuleExamples"
                            [selectedEntity]="selectedEntity"
                            [entityMap]="entityMap"
                            [tasksInProgress]="tasksRunning"
                            [dataRule]="dataRule"
                            (appliedToBullhornEmitter)="onAppliedToBullhorn()"
        ></app-examples-found>
      </mat-expansion-panel>
    </mat-accordion>

  </form>
  <!--<span style="background-color: lightgreen">{{form.value | json}} | valid={{form.valid}}, dirty={{form.dirty}}</span>-->
</aside>
